import React from 'react';

import InfoIcon from 'icons/info.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DatePickerField from 'components/application/DatePickerField';
import ErrorMessage from 'components/application/ErrorMessage';
import TextArea from 'components/application/TextArea';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function BookingSidePanelForm({
  currentBooking,
  onDateChange,
  onInputChange,
  removeErrorStyling,
  requestError,
}) {
  const { t: i18nTCommon } = useTranslation('common');

  return (
    <div className='popup__body-form--light'>
      <div className='tw-m-0 tw-mb-5 tw-flex tw-rounded-lg tw-border-0 tw-bg-cyan-025 tw-p-3 tw-text-cyan-800'>
        <div className='tw-mr-3 tw-h-5'>
          <InfoIcon
            className='[&_path]:tw-fill-cyan-800'
            height={20}
            width={20}
          />
        </div>
        <p className='tw-m-0'>
          {i18nTCommon('personnel.emailNotifications.personnelAndLineManager')}
        </p>
      </div>
      <div className='tw-mb-6'>
        <ErrorMessage
          isFallback={requestError.isFallback}
          modifiers='side-panel__alert side-panel__alert--danger side-panel__alert--wide'
          validationErrors={requestError.validationErrors}
          wrapperClassName='form-container'
        />
      </div>
      <div className='form-container'>
        <div className='tw-flex tw-justify-start'>
          <div className='tw-mr-3'>
            <DatePickerField
              earliestDate={new Date()}
              fieldError={requestError.validationErrors.date}
              isRequired={true}
              label={i18nTCommon('shared.date')}
              name='date'
              onChange={onDateChange}
              removeErrorStyling={removeErrorStyling}
              value={currentBooking.date}
            />
          </div>
        </div>
        <TextArea
          label={i18nTCommon('bookings.bookingNotes')}
          name='notes'
          onChange={onInputChange}
          tooltip={i18nTCommon('bookings.bookingNotesAreIncludedInTheEmail')}
          value={currentBooking.notes}
        />
      </div>
    </div>
  );
}

BookingSidePanelForm.propTypes = {
  requestError: PropTypes.object,
  currentBooking: resourceShape('booking').isRequired,
  removeErrorStyling: PropTypes.func,
  onDateChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
};
